import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Extra } from 'src/app/shared/classes/extra';

@Component({
  selector: 'app-extras-dialog',
  templateUrl: './extras-dialog.component.html',
  styleUrls: ['./extras-dialog.component.scss']
})
export class ExtrasDialogComponent implements OnInit{

  onExtraEvent: EventEmitter<Extra> = new EventEmitter<Extra>();

  constructor(
    public dialogRef: MatDialogRef<ExtrasDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

    ngOnInit()
    {
      this.data.extras = this.data.extras.sort((a, b) => {
        return a.price - b.price;
      });
    }

    onChosenExtra(extra): void {
      this.onExtraEvent.emit(extra);
  }

  getTotalPrice(extraPrice: number)
  {
    return this.data.basePrice + extraPrice;
  }

}
